var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResetThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.25h-5V10a7.5 7.5 0 117.5 7.5h-1.25V20H15A10 10 0 105 10v1.25H0l6.25 6.25z",
    fill: "currentcolor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "92c8bfefcf6aa4b3e1b3a536bbe0747c.svg";
export { SvgResetThick as ReactComponent };